export const transform = (item) => {
  return {
    question: item.faq,
    answer: item.answer,
    category: item.categoryName,
    imageUrl: item.imageUrl,
  }
}

export const transformMany = (items) => {
  return items.map((item) => transform(item))
}
